// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__5c3a1","profile1":"Profile_profile1__IDNx+"};